module.exports = __webpack_public_path__ + "img/120.6f7e9baa.png";